module.exports = __webpack_public_path__ + "img/search-maps.1f0d38d1.svg";